import React from "react";
import { Link, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "../../../Services/axiosCommon";

import { BackButton } from "../../../Components/Utils/Buttons";

import ViewFiles from "./viewFiles";
import Breadcrumb from "../../../Components/Utils/Breadcrumb";
import Dashboard from "../Dashboard";
import NuDate from "../../../Components/Utils/NuDate";


function NotesView() {
  const { notesId,officeId } = useParams();
  const [note, setNotes] = useState([]);
  const [file, setFile] = useState([]);

  const getNotesDetails = async () => {
    await axios
      .get(`/Notes/${notesId}`)
      .then(async (res) => {
        res?.data?.data && setFile(res?.data?.data?.attachments || []);
        (await res?.data?.data) && setNotes(res?.data?.data);
      })
      .catch((error) => console.error("error", error));
  };
  useEffect(() => {
    getNotesDetails();
  }, []);

  return (
    <div className="w-full h-[90vh] px-4 py-2 overflow-hidden ">
      <div className="md:flex justify-between w-full">

        <Breadcrumb
          items={[
            {
              name:"My Diary",
              link:`/dairy/`
            },
            { name: "View" },
               ]}
        />
        <div className=" flex justify-between items-center float-right">
          <BackButton />
        </div>
      </div>
      <div className=" w-full  h-[90%] mt-3 bg-white rounded-lg shadow-[0px_4px_16px_rgba(17,17,26,0.1),_0px_8px_24px_rgba(17,17,26,0.1),_0px_16px_56px_rgba(17,17,26,0.1)] p-4  overflow-y-auto">
        <div className=" w-full h-full">
          <div className=" w-full md:flex gap-3 mb-3">
            <div className=" w-full md:w-[70%] ">
              <h3 className=" text-sm font-medium text-mainColor-400">
                {note?.title || "-"}
              </h3>
            </div>

            <div className=" w-full md:w-[28%] text-[12px] font-medium text-slate-600">
              
              <div className=" w-full md:w-[85%] flex justify-between gap-2 items-center">
                <span>Status :</span> <span className=" ml-2 font-normal">{note?.status || "-"} </span>
              </div>
              
            <div className=" w-full md:w-[85%] flex justify-between gap-2 items-center">
                Due Date :
                <span className=" ml-2 font-normal">
                  {note?.due_date != "" || note?.due_date != "None" ? (
                    <NuDate value={note?.due_date} format="DD-MMM-YYYY" />
                  ) : (
                    " "
                  )}
                </span>
              </div>

              <div className="w-full md:w-[85%] flex justify-between gap-2 items-center">
                Reminder :
                <span className=" ml-2 font-normal">
                  {note?.reminder_date != "" ||
                  note?.reminder_date != "None" ? (
                    <NuDate value={note?.reminder_date} format="DD-MMM-YYYY" />
                  ) : (
                    " "
                  )}
                  {note?.reminder_time != "" &&
                  note?.reminder_time != "00:00:00"
                    ? note?.reminder_time
                    : " "}
                </span>
              </div>

              
            </div>
          </div>

          <div className="  w-full mt-2 mb-5">
            <pre className=" w-full text-xs  text-justify whitespace-pre-wrap">
              {note?.description || "-"}
            </pre>
          </div>
          {file && file.length > 0 && (
            <>
              <h3 className=" text-xs font-medium text-mainColor-400">
                Attachments
              </h3>
              <div className=" w-full p-2 flex gap-3 items-center flex-wrap">
                {file.map((image, idx) => {
                  return <ViewFiles data={image} key={idx} />;
                })}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default NotesView;
